import { Stack } from "@mui/joy";
import SidebarTaskListForCoach from "./SidebarTaskListForCoach";
import SidebarPatientListForCoach from "./SidebarPatientListForCoach";

export default function SidebarLayoutForCoach() {
  return (
    <Stack direction="row" sx={{ height: "100vh", overflow: "hidden" }}>
      <SidebarPatientListForCoach />
      <SidebarTaskListForCoach />
    </Stack>
  );
}